import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Config from "./../config.json";

export const cropApi = createApi({
  reducerPath: "cropApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${Config.IPM_SERVER_URL}/api/crops/`,
    credentials: "include",
    headers: {
      "X-API-Key": Config.X_API_KEY,
    },
  }),
  endpoints: (builder) => ({
    getAllCrops: builder.query({
      query: () => ({
        url: "getAll",
        params: {},
        method: "GET",
      }),
      providesTags: (result) => [
        { type: "Crop", id: "List" },
        ...(result ?? []).map((Crop) => ({ type: "Crop", id: Crop.id })),
      ],
    }),
    getAllCropsWithDetails: builder.query({
      query: () => ({
        url: "get-all-crops-with-details",
        params: {},
        method: "GET",
      }),
    }),
    createCrops: builder.mutation({
      query: (crop) => ({
        url: "create",
        body: crop,
        method: "POST",
      }),
      invalidatesTags: [
        { type: "Crop", id: "List" },
        { type: "Crop", id: (id) => id },
      ],
    }),
    updateCrop: builder.mutation({
      query: (crop) => ({
        url: `updateCrop`,
        body: crop,
        method: "PUT",
      }),
      invalidatesTags: [
        { type: "Crop", id: "List" },
        { type: "Crop", id: (id) => id },
      ],
    }),
    deleteCrop: builder.mutation({
      query: (id) => ({
        url: `DeleteCrop/${id}`,
        body: id,
        method: "DELETE",
      }),
      invalidatesTags: [
        { type: "Crop", id: "List" },
        { type: "Crop", id: (id) => id },
      ],
    }),
    deleteUploadedImage: builder.mutation({
      query: (id) => ({
        url: `deleteUploadedImage/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [
        { type: "Crop", id: "List" },
        { type: "Crop", id: (id) => id },
      ],
    }),
  }),
});

export const {
  useDeleteUploadedImageMutation,
  useGetAllCropsQuery,
  useGetAllCropsWithDetailsQuery,
  useCreateCropsMutation,
  useUpdateCropMutation,
  useDeleteCropMutation,
} = cropApi;
